import { render, staticRenderFns } from "./statistical-analysis-general-statistics-general.vue?vue&type=template&id=c8a43ad6&scoped=true&"
import script from "./statistical-analysis-general-statistics-general.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-general-statistics-general.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-general-statistics-general.scss?vue&type=style&index=0&id=c8a43ad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a43ad6",
  null
  
)

export default component.exports